import { WebContext } from "VSS/Common/Contracts/Platform";
import { getService } from "VSS/Service";
import { WorkItemTemplateService } from "WorkItemTracking/Scripts/Services/WorkItemTemplateService";

/**
 * **
 * Returns an instance of the WorkItemTemplateService making sure it's cached
 * at the project level.
 * WorkItemTemplateService contains data for all templates in a project, so it
 * shouldn't be cached by VssConnection at the team level.
 * @param context WebContext to use for getting a connection.
 */
 export function GetWorkItemTemplateService(context: WebContext): WorkItemTemplateService {
    const serviceContext = <WebContext>{
        ...context,
        team: null
    };

    return getService<WorkItemTemplateService>(WorkItemTemplateService, serviceContext);
}
